import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "w-full"
};
import LlSelect from '@/components/LlSelect.vue';
import archiveOptions from '@/constants/archiveOptions';
export default {
  __name: 'LlShowArchived',
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const onUpdate = val => {
      emit('update:modelValue', val);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("label", {
        class: "pr-2 py-1 text-sm"
      }, "Show Archived", -1)), _createVNode(LlSelect, {
        "model-value": __props.modelValue,
        items: _unref(archiveOptions),
        "item-title": "label",
        "item-value": "status",
        density: "compact",
        class: "at-choose-client remove-outline",
        "return-object": "",
        variant: "outlined",
        "hide-details": "true",
        isAutocomplete: true,
        "onUpdate:modelValue": onUpdate
      }, null, 8, ["model-value", "items"])]);
    };
  }
};